module Core {
    angular.module('core', ['configuration', 'localization', 'ui.router', 'ngMessages', 'ngAnimate', 'ngTouch', 'nvd3', 'rzModule', 'as.sortable', 'ui.knob', 'ngCookies']);
}